import { render, staticRenderFns } from "./Loyalty.vue?vue&type=template&id=3db3a1d0&"
import script from "./Loyalty.vue?vue&type=script&lang=js&"
export * from "./Loyalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports